<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Add Bulk Comments
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="CommentType">
              <b-select
                name="comment_type"
                v-model="comment_type_selected"
                expanded
                placeholder="Please select"
                data-cy="comment_type"
              >
                <option
                  v-for="(option, index) in comment_type"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Comment">
              <b-input type="textarea" name="comment" v-model="comment" />
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" type="is-primary" @click="submit">
          Add Comments
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Abort
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>
<script>
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
// @group Reporting Tracker
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    checkedRows: {
      type: Array,
      default: null
    },
    filters: {
      type: String,
      default: null
    },
    checkedAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      comment_type_selected: null,
      comment: null,
      isModalActive: false,
      comment_type: ["External", "Internal"],
      reportingTrackerService: new ReportingTrackerDataService()
    };
  },
  methods: {
    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    submit() {
      if (this.comment_type_selected != null) {
        this.reportingTrackerService
          .bulkAddComment(
            this.checkedRows.map(records => records.id),
            this.filters,
            this.checkedAll,
            this.comment,
            this.comment_type_selected
          )
          .subscribe(response => {
            if (response["error"]) {
              this.$buefy.dialog.alert({
                title: "Error",
                message: response["error"]
              });
              return false;
            } else {
              this.$buefy.dialog.alert({
                title: "Success",
                message: "Comment updated"
              });
              this.$emit(
                "viewConfirm",
                this.comment,
                this.comment_type_selected
              );
              this.comment = null;
              this.comment_type_selected = null;
            }
          }, this.handleApiError);
      } else {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select comment type from the list!",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
